import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { take } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { LanguageService } from '../../shared/services/language/language.service';
import { PublicLanguagesService } from '../../shared/services/language/public-languages.service';
import { PublicLanguage } from '../../shared/models/public-language';
import { LanguageSwitcherConfirmDialogComponent } from './confirm-dialog/language-switcher-confirm-dialog.component';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {
    @Input() uuid?: string;

    languages: PublicLanguage[] = [];

    get currentLanguage(): PublicLanguage | undefined {
        return this.languages.find(l => l.tag === this.languageService.currentLocale);
    }

    constructor(
        public languageService: LanguageService,
        private dialog: MatDialog,
        private publicLanguagesService: PublicLanguagesService
    ) {}

    ngOnInit(): void {
        const langs$ = this.uuid
            ? this.publicLanguagesService.getAllByUuid(this.uuid)
            : this.publicLanguagesService.getAll();

        langs$.pipe(take(1)).subscribe(langs => {
            this.languages = langs.map(l => ({
                ...l,
                countryFlag: l.countryFlag ? `${environment.api}${l.countryFlag}` : null,
            }));
        });
    }

    onSelectLanguage(lang: PublicLanguage): void {
        if (lang.tag === this.languageService.currentLocale) return;
        this.dialog.open(LanguageSwitcherConfirmDialogComponent, {
            data: { locale: lang.tag, label: lang.name },
            width: '600px',
        });
    }
}
